import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import MediaImage from '../../../Generics/Media/MediaImage'
import ProductPrices from '../../ProductDetail/components/productPrices'
import ProductName from '../../ProductName'
import ProductCtas from '../../ProductCtas/ProductDetailsCta'

const StyledRoot = styled.div(({ theme: { breakpoints } }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  flexDirection: 'column',

  [`@media (min-width: ${breakpoints.large})`]: {
    justifyContent: 'space-between',
    flexDirection: 'row',
  },
}))

const StyledHeader = styled.div(({ theme: { breakpoints } }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  [`@media (min-width: ${breakpoints.large})`]: {
    flex: 2,
  },
}))

const StyledCtas = styled.div(({ theme: { spaces, breakpoints } }) => ({
  [`@media (min-width: ${breakpoints.large})`]: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    paddingLeft: spaces.default / 2,
  },
}))

const StyledPreviewImage = styled.div(() => ({
  width: 113,
  height: 113,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',

  '> img': {
    maxWidth: '100%',
    maxHeight: '100%',
  },
}))

const StyledDetails = styled.div(({ theme: { spaces } }) => ({
  flex: 2,
  padding: `0 ${spaces.default / 2}px`,
}))

const Preview = ({
  productId,
  productImage,
  hideProductsTitle,
  name,
  sale,
  price,
  prefixPrice,
  suffixPrice,
  discountedPrice,
}) => (
  <StyledRoot>
    <StyledHeader>
      <StyledPreviewImage>
        <MediaImage
          lazy={false}
          src={productImage}
        />
      </StyledPreviewImage>
      <StyledDetails>
        <ProductName
          name={name}
          hideProductsTitle={hideProductsTitle}
          previewMode
        />
        <ProductPrices
          price={price}
          prefixPrice={prefixPrice}
          suffixPrice={suffixPrice}
          sale={sale}
          discountedPrice={discountedPrice}
          previewMode
        />
      </StyledDetails>
    </StyledHeader>
    <StyledCtas>
      <ProductCtas productId={productId} previewMode />
    </StyledCtas>
  </StyledRoot>
)

Preview.propTypes = {
  productId: PropTypes.string.isRequired,
  hideProductsTitle: PropTypes.bool,
  name: PropTypes.string,
  sale: PropTypes.string,
  price: PropTypes.string,
  prefixPrice: PropTypes.string,
  suffixPrice: PropTypes.string,
  productImage: PropTypes.string,
  discountedPrice: PropTypes.string,
}

Preview.defaultProps = {
  hideProductsTitle: false,
  name: '',
  sale: '',
  price: '',
  prefixPrice: '',
  suffixPrice: '',
  productImage: '',
  discountedPrice: '',
}

export default React.memo(Preview)
